import Api from "../services/api";

export const getLocations = () => {
    return Api.get('/location');
}

export const createOrderCall = async (data: any) => {
    return await Api.post('/order', data)
}
